import { PopupType } from '../../../components/popup/types';
import { gameStateActions } from '../../../store/slices/game/slice';
import { popupActions } from '../../../store/slices/popup/slice';
import type { GameCommunicationMessageType } from '../types';
import { MessageName } from '../types';

import { BaseCoreGameCommunicationProcessor } from './BaseCoreGameCommunicationProcessor';

interface TableCloseMessage extends GameCommunicationMessageType {
  openTime?: number;
}

export class CoreTableClosedGameCommunicationProcessor extends BaseCoreGameCommunicationProcessor {
  public messageName = MessageName.TableClosed;

  public process(message: TableCloseMessage): void {
    if (message?.openTime) {
      this.store.dispatch(gameStateActions.setTable({ openTime: message.openTime }));
    }
    this.store.dispatch(popupActions.overwritePopup(PopupType.TableClosed));
    this.store.dispatch(gameStateActions.setGamePaused(true));
  }
}
